import {
  applySpeciesCriteriaMetPipeline,
  CRITERIA_STATUS_FILTER_ALL,
  TAXONOMIC_GROUP_FILTER_ALL,
  UNDER_ASSESSMENT_FILTER
} from 'utils/speciesCriteriaMet'

const getSpeciesKey = (item) => item.scientificName || String(item.id)

const getToolbarSpecies = (calculationData = []) => {
  const seen = new Set()

  return calculationData.filter((item) => {
    const key = getSpeciesKey(item)

    if (seen.has(key)) {
      return false
    }

    seen.add(key)
    return true
  }).map((item) => ({
    id: item.id,
    taxonomicGroup: item.taxonomicGroup || item.taxonGroup,
    scientificName: item.scientificName,
    specieName: item.specieName || item.commonName,
    commonName: item.commonName,
    criteriaStatus: item.criteriaStatus,
    underAssessment: item.underAssessment
  }))
}

export const getCalculationSpeciesCounts = (calculationData = [], filters = {}) => {
  const {
    search = '',
    taxonomicGroup = TAXONOMIC_GROUP_FILTER_ALL,
    criteriaStatus = CRITERIA_STATUS_FILTER_ALL,
    underAssessment = UNDER_ASSESSMENT_FILTER.ALL
  } = filters

  const toolbarSpecies = getToolbarSpecies(calculationData)
  const filteredSpecies = applySpeciesCriteriaMetPipeline(toolbarSpecies, {
    search,
    taxonomicGroup,
    criteriaStatus,
    underAssessment,
    sort: null
  })

  return {
    totalCount: toolbarSpecies.length,
    filteredCount: filteredSpecies.length
  }
}

export const filterCalculationData = (calculationData = [], filters = {}) => {
  const {
    search = '',
    taxonomicGroup = TAXONOMIC_GROUP_FILTER_ALL,
    criteriaStatus = CRITERIA_STATUS_FILTER_ALL,
    underAssessment = UNDER_ASSESSMENT_FILTER.ALL
  } = filters

  const toolbarSpecies = getToolbarSpecies(calculationData)
  const matchingSpecies = new Set(
    applySpeciesCriteriaMetPipeline(toolbarSpecies, {
      search,
      taxonomicGroup,
      criteriaStatus,
      underAssessment,
      sort: null
    }).map((species) => species.scientificName)
  )

  return calculationData.filter((item) => matchingSpecies.has(item.scientificName))
}

export const getCalculationToolbarSpecies = getToolbarSpecies
